(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7367],{

/***/ 22537:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/remix-authentication",
      function () {
        return __webpack_require__(20002);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SaneImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53822);



function SaneImage(param) {
    let { src , height , width , layout , wrapClassName , ...props } = param;
    const { dimensions , format  } = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .decodeAssetId */ .h9)(src.asset._ref);
    const url = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_2__/* .urlForImage */ .iQ)(src.asset).url() || "";
    const newHeight = height ? height : width ? width / dimensions.width * dimensions.height : format === "svg" || src.lowresolution ? dimensions.height : dimensions.height / 2;
    const newWidth = width ? width : height ? height / dimensions.height * dimensions.width : format === "svg" || src.lowresolution ? dimensions.width : dimensions.width / 2;
    const customDimensions = layout ? {
        layout
    } : {
        height: newHeight,
        width: newWidth
    };
    return format === "gif" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: url,
        height: newHeight,
        width: newWidth,
        alt: src.alt
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: wrapClassName || "image-wrap",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            alt: src.alt,
            ...props,
            ...customDimensions,
            src: url
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (SaneImage);


/***/ }),

/***/ 83976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ GetStarted; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/ArrowSmRightIcon.js
var ArrowSmRightIcon = __webpack_require__(79526);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/solutions/doc-link.tsx


function DocLink(param) {
    let { doc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-1 my-2 rounded-md",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            legacyBehavior: true,
            href: doc,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "flex items-center justify-center px-8 py-3 text-base font-medium bg-white border border-transparent rounded-md text-clerk-blue md:w-full hover:bg-gray-50 md:py-4 md:text-lg md:px-10 btn btn-outline",
                children: "Explore the docs"
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/solutions/get-started.tsx



function GetStarted(param) {
    let { doc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "mt-10 mb-6",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full px-4 mx-auto mt-5 sm:px-0 sm:flex-row sm:flex sm:justify-center md:mt-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DocLink, {
                    doc: doc
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "my-2 rounded-md sm:mx-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: "".concat("https://dashboard.clerkstage.dev", "/sign-up"),
                        className: "flex items-center justify-center px-8 py-3 text-base font-medium text-white border border-transparent rounded-md md:w-full bg-clerk-blue hover:bg-blue-700 md:py-4 md:text-lg md:px-10 btn",
                        children: [
                            "Start building now",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowSmRightIcon/* default */.Z, {
                                className: "w-6 h-6 ml-1 -mr-1.5"
                            })
                        ]
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 49596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ SmallQuote; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27013);


function SmallQuote(param) {
    let { quote , image , name , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-4 py-10 sm:px-8 lg:px-8",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("blockquote", {
            className: "max-w-3xl mx-auto font-medium",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "text-lg text-center sm:text-xl md:leading-9 md:text-2xl",
                    children: [
                        "“",
                        quote,
                        "”"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-row items-center justify-center mt-4 md:mt-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-10 h-10 mr-4 overflow-hidden rounded-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components__WEBPACK_IMPORTED_MODULE_1__/* .SaneImage */ .Q, {
                                src: image
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "md:flex md:items-center md:justify-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-900",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "hidden w-5 h-5 mx-1 text-indigo-600 md:block",
                                    fill: "currentColor",
                                    viewBox: "0 0 20 20",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M11 0h3L9 20H6l5-20z"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-gray-500",
                                    children: title
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 20002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ RemixPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/sanity/sane-image.tsx
var sane_image = __webpack_require__(27013);
// EXTERNAL MODULE: ./components/solutions/get-started.tsx + 1 modules
var get_started = __webpack_require__(83976);
// EXTERNAL MODULE: ./components/solutions/small-quote.tsx
var small_quote = __webpack_require__(49596);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/CheckIcon.js
var CheckIcon = __webpack_require__(64343);
;// CONCATENATED MODULE: ./components/solutions/remix/auth-your-way.tsx


const authentications = [
    {
        name: "Passwords",
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: 'Not just any "magic word" is safe – we use HaveIBeenPwned to block credential stuffing'
        })
    },
    {
        name: "OAuth & Social",
        description: "The fastest solution to signing in, and it's preferred by most users when available"
    },
    {
        name: "Email Passcodes (OTP)",
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Ask users to relay a 6 digit passcode sent to their email – simple but effective!"
        })
    },
    {
        name: "Email Magic Links",
        description: "Made popular by Slack, send users a link that automatically signs them in"
    },
    {
        name: "Web3 (Metamask)",
        description: "Fast like OAuth, but with a privacy-conscious keypair instead of a third-party vendor"
    },
    {
        name: "SMS Passcodes (OTP)",
        description: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Ask users to relay a 6 digit passcode sent to their phone – great for mobile!"
        })
    }
];
function AuthYourWay() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-10 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative lg:grid lg:grid-cols-3 lg:gap-x-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                children: "Authenticate users any way you want"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "max-w-3xl mt-3 text-lg text-gray-500",
                                children: "Easily choose one or many ways for your users to sign in."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-12 lg:mt-0 lg:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                            className: "space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:grid-rows-3 sm:grid-flow-col sm:gap-x-6 sm:gap-y-10 lg:gap-x-8",
                            children: authentications.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                                    className: "absolute w-6 h-6 text-green-500",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-lg font-medium leading-6 text-gray-900 ml-9",
                                                    children: feature.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                            className: "mt-2 text-base text-gray-500 ml-9",
                                            children: feature.description
                                        })
                                    ]
                                }, feature.name))
                        })
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/solutions/remix/prebuilt-components.tsx


function PrebuiltComponents(param) {
    let { image  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative lg:grid lg:grid-cols-3 lg:gap-x-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:col-span-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                                children: "Use high-conversion, beautiful components"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "max-w-3xl mt-3 text-lg text-gray-500",
                                children: "We built user management UIs so you don't have to – free in every plan! Mount them in React, or let Clerk host them for you."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-10 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 lg:mt-0 lg:col-span-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-xl font-medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            children: "<SignUp/>"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                                        wrapClassName: "image-wrap rounded rounded-lg shadow shadow-lg",
                                        src: image.componentSignUp
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-xl font-medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            children: "<SignIn/>"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                                        wrapClassName: "image-wrap rounded rounded-lg shadow shadow-lg",
                                        src: image.componentSignIn
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-xl font-medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            children: "<UserProfile/>"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                                        wrapClassName: "image-wrap rounded rounded-lg shadow shadow-lg",
                                        src: image.componentUserProfile
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-2 text-xl font-medium",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                                            children: "<UserButton/>"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                                        wrapClassName: "image-wrap rounded rounded-lg shadow shadow-lg",
                                        src: image.componentUserButton
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/CursorClickIcon.js
var CursorClickIcon = __webpack_require__(74000);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/TemplateIcon.js
var TemplateIcon = __webpack_require__(92691);
;// CONCATENATED MODULE: ./components/solutions/remix/remix-contents.tsx


const features = [
    {
        name: "Loaders and Actions",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Simply call ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                    children: "getAuth(request)"
                }),
                " to access the active user ID and session ID"
            ]
        }),
        icon: CursorClickIcon/* default */.Z
    },
    {
        name: "React (Server and Client)",
        description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                "Call ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                    children: "useUser()"
                }),
                " to access profile information, or",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                    children: "useAuth()"
                }),
                " for a signed JWT with session data"
            ]
        }),
        icon: TemplateIcon/* default */.Z
    }
];
function RemixContexts() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "my-10 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative lg:grid lg:grid-cols-3 lg:gap-x-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "lg:col-span-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl",
                            children: "Access user data in any Remix context"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dl", {
                        className: "mt-10 space-y-10 sm:space-y-0 sm:grid sm:grid-cols-2 sm:gap-x-8 sm:gap-y-10 lg:mt-0 lg:col-span-2",
                        children: features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center justify-center w-12 h-12 text-white rounded-md bg-clerk-blue",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(feature.icon, {
                                                    className: "w-6 h-6",
                                                    "aria-hidden": "true"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mt-5 text-lg font-medium leading-6 text-gray-900",
                                                children: feature.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                        className: "mt-2 text-base text-gray-500",
                                        children: feature.description
                                    })
                                ]
                            }, feature.name))
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(58038);
;// CONCATENATED MODULE: ./pages/solutions/remix-authentication.tsx





var __N_SSG = true;
function RemixPage(props) {
    const { image , text  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "mt-10 mb-32",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative pt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-4 mx-auto max-w-7xl sm:px-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: "text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl md:text-6xl xl:text-7xl",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block",
                                                children: "The easy solution to"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "block text-clerk-blue",
                                                children: "Remix authentication"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "max-w-md mx-auto mt-3 text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                                        children: "Add users to your Remix application in minutes"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(get_started/* GetStarted */.F, {
                        doc: constants/* URLS.remixDocs */.ns.remixDocs
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "mt-12",
                id: "quote",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(small_quote/* SmallQuote */.o, {
                    quote: text.quoteBody,
                    name: text.quoteName,
                    title: text.quoteTitle,
                    image: image.quote
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative px-4 py-12 mx-auto max-w-7xl sm:px-6 lg:px-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "md:order-last lg:mx-0 lg:col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sane_image/* SaneImage */.Q, {
                                    wrapClassName: "image-wrap rounded-xl overflow-hidden max-w-xs md:max-w-none",
                                    src: image.remixglowing
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4 md:mt-0 lg:col-span-2 lg:text-left",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "mt-1 text-3xl font-extrabold tracking-tight text-gray-900 lg:text-4xl",
                                        children: "Why Clerk for Remix authentication?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-3 text-base text-gray-500 sm:mt-4 lg:text-lg xl:text-xl",
                                        children: "Remix and Clerk are both built for speed, with native support for SSR and edge computing environments. Plus, Clerk uses JWTs so Remix authentication is stateless and takes under one millisecond."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-3 text-base text-gray-500 sm:mt-4 lg:text-lg xl:text-xl",
                                        children: "Beyond our similar philosophy, the greatest benefits of Clerk are our flexible authentication strategies, the beautiful components we provide, and our seamless integration experience. Learn more below!"
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthYourWay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrebuiltComponents, {
                ...props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RemixContexts, {})
        ]
    });
}


/***/ }),

/***/ 64343:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function CheckIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 13l4 4L19 7"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CheckIcon);

/***/ }),

/***/ 74000:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function CursorClickIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (CursorClickIcon);

/***/ }),

/***/ 92691:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function TemplateIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (TemplateIcon);

/***/ }),

/***/ 79526:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72408);


function ArrowSmRightIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ArrowSmRightIcon);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(22537); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);